// extracted by mini-css-extract-plugin
module.exports = {"secondaryButton":"styles_secondaryButton__3dw99","buttonContentLoading":"styles_buttonContentLoading__1HL2o","loadingIcon":"styles_loadingIcon__-1E3T"};